import DOMPurify from "dompurify";

export default {
    methods: {
        loadingOverlay(flag) {
            document.getElementById("loadingOverlay").style.display = flag ? "block" : "none";
        },
        changeInputType(flag) {
            return (typeof flag === "string" ? this[flag] : flag) ? "text" : "password";
        },
        changePwIcon(flag) {
            return (typeof flag === "string" ? this[flag] : flag) ? "mdi-eye-off-outline" : "mdi-eye-outline";
        },
        /**
         * * XSS 공격이란? (Cross Site Scripting)
         * * XSS 공격은 공격자가 악의적인 스크립트를 웹 페이지에 삽입하고, 다른 사용자의 브라우저에서 이 스크립트가 실행되게 만드는 보안 취약점을 이용하는 공격입니다. 
         * * 이 스크립트는 사용자의 세션 토큰이나 쿠키를 탈취하거나, 사용자를 대신하여 악의적인 행동을 수행할 수 있습니다.
         * * const dirty = '<img src=x onerror=alert(1)>'; // 악의적인 스크립트를 포함한 HTML
         * * const clean = DOMPurify.sanitize(dirty); // 살균 처리
         * * console.log(clean); -> 살균된 결과를 출력, <img src="x">
         */
        safeHTML(value) {
            return DOMPurify.sanitize(value);
        },
        getSubwayColor(value) {
            const subwayColors = {
                "1": "#0052A4",
                "2": "#009D3E",
                "3": "#EF7C1C",
                "4": "#00A5DE",
                "5": "#996CAC",
                "6": "#CD7C2F",
                "7": "#747F00",
                "8": "#E6186C",
                "9": "#BDB092",
                "인천1": "#7CA8D5",
                "인천2": "#ED8B00",
                "분당": "#FABE00",
                "신분당": "#D31145",
                "경의중앙": "#77C371",
                "공항철도": "#3681B7",
                "경춘": "#0C8E72",
                "의정부": "#F5A200",
                "용인": "#509F22",
                "경강": "#003DA5",
                "우이신설": "#B7C452",
                "서해": "#8FC31F",
                "김포골드": "#A17800",
                "신림": "#6789CA"
            };
            return subwayColors[value] || null;
        }
    }
}